var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#8A99BB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M785.23-154.08 529.15-410.15q-29.69 26.82-69.3 40.91-39.6 14.09-79.54 14.09-95.25 0-161.63-66.16-66.37-66.15-66.37-161 0-94.84 66.15-161 66.16-66.15 161.44-66.15 94.29 0 160.89 66.15 66.59 66.16 66.59 160.72 0 41.36-14.76 80.97-14.77 39.62-41.24 69.24l256.31 255.07-22.46 23.23ZM380.08-385.92q82.41 0 139.47-56.73 57.07-56.73 57.07-139.66 0-82.92-57.07-139.65-57.06-56.73-139.47-56.73-82.77 0-139.89 56.73-57.11 56.73-57.11 139.65 0 82.93 57.11 139.66 57.12 56.73 139.89 56.73Zm-50.54-115.39v-163l131.69 81.39-131.69 81.61Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSearch);
export default __webpack_public_path__ + "static/media/video-search.858075ed.svg";
export { ForwardRef as ReactComponent };